import React from "react";

export function GroupSpecialGochiKidDetailModal(props) {
  const IMAGE_NO_GROUP_SPECIAL = require("../../../../assets/img/icons/group_special_gochi_kid_blank_logo.png");

  return (
    <div
      className={
        props.showing
          ? "custom-modal-container group-special-gochi-kid-detail-modal show-modal"
          : "custom-modal-container group-special-gochi-kid-detail-modal"
      }
      size="sm"
    >
      <div
        className={
          props.showing
            ? "modal modal-action modal-dialog is-show history-modal"
            : "modal modal-action modal-dialog history-modal"
        }
      >
        <div className="modal-header-history">
          <button
            className="modal-btn modal-btn-close"
            id="modalClose"
            onClick={() => props.handleClose()}
            type="button"
          >
            <svg className="icon">
              <title>閉じる</title>
              <use xlinkHref="/assets/img/common/icon.svg#times" />
            </svg>
          </button>
        </div>
        <div className="title-modal title-modal-charge">
          <div className="title">支援者のご紹介</div>
        </div>
        <div className={`modal-body`}>
          <div className="group-special-name">
            {"「" + props.groupSpecialDetail?.gochiKidGroupName + "」"}
          </div>
          {props.groupSpecialImage?.listRank1?.length > 0 && (
            <div className="sponsor">
              <div className="row content">
                {Object.entries(props.groupSpecialImage).map(([key, obj]) => {
                  if (key === 'listRank1' && obj.length > 0) {
                    return (
                      obj.map(i => (
                        <div className="list-rank-1 col-12" key={i.gochiKidCompanyFundId}>
                          <a href={i.pageUrl} target="_blank" className="link-rank-1">
                            <img src={i.logoImage ? i.logoImage : IMAGE_NO_GROUP_SPECIAL} alt={i.companyName} width="100%" className="image-sponsor" />
                          </a>
                        </div>
                      ))
                    )
                  }
                })}
              </div>
            </div>
          )}
          {props.groupSpecialImage?.listRank2?.length > 0 && (
            <div className="sponsor">
              <div className="row content">
                {Object.entries(props.groupSpecialImage).map(([key, obj]) => {
                  if (key === 'listRank2' && obj.length > 0) {
                    return (
                      obj.map(i => (
                        <div className="list-rank-2 col-6" key={i.gochiKidCompanyFundId}>
                          <a href={i.pageUrl} target="_blank" className="link-rank-2">
                            <img src={i.logoImage ? i.logoImage : IMAGE_NO_GROUP_SPECIAL} alt={i.companyName} width="100%" className="image-sponsor" />
                          </a>
                        </div>
                      ))
                    )
                  }
                })}
              </div>
            </div>
          )}
          {props.groupSpecialImage?.listRank2?.length > 0 && (
            <div className="sponsor">
              <div className="row content">
                {Object.entries(props.groupSpecialImage).map(([key, obj]) => {
                  if (key === 'listRank3' && obj.length > 0) {
                    return (
                      obj.map(i => (
                        <div className="list-rank-3 col-4" key={i.gochiKidCompanyFundId}>
                          <a href={i.pageUrl} target="_blank" className="link-rank-3">
                            <img src={i.logoImage ? i.logoImage : IMAGE_NO_GROUP_SPECIAL} alt={i.companyName} width="100%" className="image-sponsor" />
                          </a>
                        </div>
                      ))
                    )
                  }
                })}
              </div>
            </div>
          )}
          <div className="group-special-descrition">
            {props.groupSpecialDetail?.description}
          </div>
        </div>
      </div>
      <div onClick={() => props.handleClose()} className="back-drop" />
    </div>
  );
}
